import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyDashboardViewsRPC } from "./getSurveyDashboardViewsRPC";

export class GetSurveyDashboardViewsRPCClientImpl extends GetSurveyDashboardViewsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyDashboardViewsRPC.Request): Promise<LeoRPCResult<GetSurveyDashboardViewsRPC.Response, GetSurveyDashboardViewsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/GetSurveyDashboardViews",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyDashboardViewsRPC.ResponseDTO,
      GetSurveyDashboardViewsRPC.Errors.ErrorsDTO,
      GetSurveyDashboardViewsRPC.Response,
      GetSurveyDashboardViewsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/GetSurveyDashboardViews",
      GetSurveyDashboardViewsRPC.Response.fromDTO,
      GetSurveyDashboardViewsRPC.Errors.fromDTO
    );
  }
}
